export const isGraceAppRealm = (realm?: string) => realm === 'ldap'

export const matchRealmFromUrl = (url: string): string | null => url.match(/^\/realm\/([a-z]*[^/]+)/)?.[1] || null
